import { revenueDao } from '@/service';

export default {
  state: {},
  mutations: {},
  actions: {
    async getAllRevenuesExpanded(_, payload) {
      return new Promise((resolve, reject) => {
        revenueDao
          .getAllRevenuesExpanded(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async getAllRevenues(_, payload) {
      return new Promise((resolve, reject) => {
        revenueDao
          .getAll(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async getRevenues(_, payload) {
      return new Promise((resolve, reject) => {
        revenueDao
          .getRevenues(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async getRevenue(_, payload) {
      return new Promise((resolve, reject) => {
        revenueDao
          .getOne(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async updateRevenue(_, payload) {
      return new Promise((resolve, reject) => {
        revenueDao
          .update(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async saveRevenue(_, payload) {
      return new Promise((resolve, reject) => {
        revenueDao
          .store(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    async updateInstallment(_, payload) {
      return new Promise((resolve, reject) => {
        revenueDao
          .updateInstallment(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    async destroyRevenue(_, payload) {
      return new Promise((resolve, reject) => {
        revenueDao
          .destroyy(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async weekRevenue(_, payload) {
      return new Promise((resolve, reject) => {
        revenueDao
          .weekRevenue(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },

  getters: {},
};
